import React from 'react';
import type { ReactNode } from 'react';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import './confirmation.module.scss';
import { SheModal } from '../../../../commonv3/components/molecules/layout/SheModal';
import FooterBannerPc from './images/cancel_lesson_banner_pc.png';
import FooterBannerSp from './images/cancel_lesson_banner_sp.png';

type Props = {
  headerMessage: string;
  message: ReactNode;
  rescheduleButtonText: string;
  open: boolean;
  onAbort: () => void;
  onReschedule: () => void;
  onConfirmation: () => void;
};

export class TrialLessonCancelConfirmation extends React.Component<Props> {
  render() {
    const { headerMessage, message, open, onAbort, onConfirmation, rescheduleButtonText, onReschedule } = this.props;
    return (
      <SheModal open={open} onRequestClose={onAbort} id="trial-lesson-cancel-confirmation">
        <div styleName="confirmation trial-lesson-cancel-confirmation">
          <div styleName="header-message">{headerMessage}</div>
          <div styleName="message">{message}</div>
          <div styleName="trial-lesson-button-wrapper">
            <Button
              id="reschedule-button"
              styleName="button"
              type="primary"
              size="m"
              disabled={false}
              onClick={onReschedule}
            >
              {rescheduleButtonText}
            </Button>
            <p styleName="confirmation-text-link">
              キャンセルご希望の方は
              <span styleName="link" onClick={onConfirmation} id="confirm-cancel-button">
                こちら
              </span>
            </p>
          </div>
          <div styleName="footer-banner">
            <img
              src={GlobalStatesV3.viewport.isDesktop ? FooterBannerPc : FooterBannerSp}
              alt="体験レッスン参加後95％の方が「満足」と回答！"
              width="100%"
            />
          </div>
        </div>
      </SheModal>
    );
  }
}
